import { createAction } from "typesafe-actions";
import { AgencyDetails } from "@app/profile/types/interfaces";

const LOAD_AGENCY = "[Agency] Load Agency";

export const LoadAgency = createAction(
  LOAD_AGENCY,
  (agency: AgencyDetails) => agency
)<AgencyDetails>();
